import { Component, forwardRef, signal } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { InputMask } from 'primeng/inputmask';

@Component({
  selector: 'app-let-input-cpr',
  imports: [FormsModule, InputMask],
  templateUrl: './let-input-cpr.component.html',
  styleUrl: './let-input-cpr.component.css',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LetInputCprComponent),
      multi: true
    }
  ]
})
export class LetInputCprComponent implements ControlValueAccessor {
  valueSignal = signal<string | undefined>(undefined);
  isDisabled = false;

  private onChange: any = () => {
    console.log('onChange');
  };
  private onTouch: any = () => {
    console.log('onTouch');
  };

  writeValue(value: string): void {
    if (value) {
      this.valueSignal.set(value);
    } else {
      this.valueSignal.set(undefined);
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  onValueChange(newValue: string): void {
    this.valueSignal.set(newValue);
    this.onChange(newValue.replaceAll('-', ''));
    this.onTouch();
  }
}
